import { useRef, useState } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { MathJaxOutput } from "../mathJax/MathJaxOutput";
import { Checkbox } from "@mui/material";

function CheckboxGroupAnswer(props: any) {
  const ref = useRef();
  const onValueChange = async (event: any) => {
    const p: string[] = checked.length ? checked.split(";") : [];
    if (p.includes(event.target.value)) {
      p.splice(p.indexOf(event.target.value), 1);
    } else {
      p.push(event.target.value);
    }
    const c = p.join(";");
    setChecked(c);
    props.onChange({ target: { id: props.id, value: c } });
  };
  const [checked, setChecked] = useState("");
  return (
    <RadioGroup {...props} ref={ref}>
      {props.answerlist.map((answer: any) => (
        <FormControlLabel
          key={answer}
          label={<MathJaxOutput text={answer} />}
          control={
            <Checkbox
              value={answer}
              disabled={props.disabled}
              id={props.id}
              checked={
                props.answer ? props.answer.split(";").includes(answer) : false
              }
              onChange={onValueChange}
              className={"RadioButtonAnswer"}
            />
          }
        />
      ))}
    </RadioGroup>
  );
}

export default CheckboxGroupAnswer;
